// Libraries
import { QueryResult, useQuery } from "@apollo/client";
// API
import { GET_IMPORT_RESULT } from "api/Import/CustomImport/queries";
import { ImportResult, ImportResultVariables } from "api/Import/CustomImport/types/ImportResult";

interface UseGetImportResultOptions {
  skip?: boolean;
}

export const useGetImportResult = (
  taskId: string,
  { skip = true }: UseGetImportResultOptions = {},
): QueryResult<ImportResult, ImportResultVariables> =>
  useQuery<ImportResult, ImportResultVariables>(GET_IMPORT_RESULT, {
    /*
     * Chris @ 13 Sep 2021:
     *
     * We should be handling this by using `stopPolling()` in the consuming component, but it doesn't work!
     * It just keeps polling.
     *
     * Instead I've forced `pollInterval` to 0 here if `skip = true`
     *
     * Source: https://github.com/apollographql/react-apollo/issues/3129
     */
    pollInterval: skip ? 0 : 1000,
    skip,
    variables: {
      task: taskId,
    },
  });
